// sessionStorage keys
export const SESSION_STORAGE_KEYS = {
  // ログインユーザー情報（id, email, name）
  MEMBER: 'member',
  // 閲覧済み記事IDリスト（レコメンド用）
  VIEWED_ARTICLES: 'viewedArticles',
  // 認証エラー発生フラグ（401/404時にセット）
  UNAUTHORIZED_ERROR: 'unauthorized_error',
  // メールログインフラグ（SNSログインと区別）
  EMAIL_LOGIN: 'email_login',
  // オンボーディングモーダル閉じたフラグ
  ONBOARDING_MODAL_CLOSED: 'onboardingModalClosed',
  // ロールモデルファインダーの状態保持
  ROLE_MODEL_FINDER_STATE: 'roleModelFinderState',
  // HOME画面のランダム検索ワード
  RANDOM_SEARCH_WORDS: 'randomSearchWords',
  // プレビューボタン無効化フラグ
  PREVIEW_DISABLED_BUTTON: 'previewDisabledButton',
  // 退会完了メッセージフラグ
  QUIT_MESSAGE: 'quitMessage',
  // 追加情報入力完了フラグ
  ADDITIONAL_INFO_COMPLETED: 'additional_info_completed',
} as const

// localStorage keys
export const LOCAL_STORAGE_KEYS = {
  // SNSログインフラグ（Google/Twitter等）
  SNS_LOGIN: 'snsLogin',
  // ログイン前のパス（ログイン後リダイレクト用）
  BEFORE_PATH: 'beforePath',
} as const

// cookie keys
export const COOKIE_KEYS = {
  // Cookieポリシー同意済みフラグ
  READ_COOKIE_POLICY: 'read_cookie_policy',
  // ロールモデルファインダーの企業IDバッファ
  RMF_COMPANY_IDS_BUFFER: 'rmf_company_ids_buffer',
  // 認証エラー発生フラグ（cookie版）
  UNAUTHORIZED_ERROR: 'unauthorized_error',
} as const

// 型定義
export type SessionStorageKey = (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS]
export type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS]
export type CookieKey = (typeof COOKIE_KEYS)[keyof typeof COOKIE_KEYS]
